'use strict';

/**
 * Configuration object containing all DOM selectors used in the SFS logic.
 */
const SFS_SELECTORS = {
    MAIN_CONTAINER: '#id-product-detail-main',
    SFS_MARKER: '[data-is-potential-sfs="true"]',
    ATTR_CONTAINER: (id) => `[data-attr="${id}"]`,
    SWATCH_SPAN: (value) => `span[data-attr-value="${value}"]`,
    HINT_AVAILABILITY: '.js-availability-hint',
    HINT_INFO_HIDDEN: '.js-hidden-variation-unavailable-hint',
    TRIGGER_EVENT: 'pdp:triggerCheckSFSAvailability',
    A2B_BUTTON: '.js-add-to-cart'
};

$(document).ready(function() {
    
    /**
     * Entry point for SFS availability logic. Validates if check is enabled,
     * fetches data from SAP CAR, and triggers DOM updates.
     * * @param {Event} [event] - The event object if triggered by an event listener.
     */
    function handleSFSCheck(event) {
        const sfsMarker = document.querySelector(SFS_SELECTORS.SFS_MARKER);
        const mainDiv = document.querySelector(SFS_SELECTORS.MAIN_CONTAINER);

        if (mainDiv && mainDiv.dataset.sfsCheckEnabled === 'true') {
            const checkSFSUrl = mainDiv.dataset.sfsCheckurl; 
            const errorLabel = mainDiv.dataset.sfsErrorlabelNotavailable;

            if (sfsMarker && checkSFSUrl) {
                $.ajax({
                    url: checkSFSUrl,
                    type: 'GET',
                    success: (response) => {
                        handleCARAvailability(response, sfsMarker, errorLabel);
                    },
                    error: (err) => {
                        sfsMarker.remove(); // Cleanup marker even on failure
                    }
                });
            }
        } else {
             sfsMarker.remove();
        }
    }

    // Listen for custom trigger from PDP interactions
    $('body').on(SFS_SELECTORS.TRIGGER_EVENT, handleSFSCheck);

    // Initial check on page load
    handleSFSCheck(); 
});

/**
 * Parses SAP CAR response and updates swatch states (selectable/selected).
 * Updates the availability hint UI if the currently selected item is unavailable.
 * * @param {Object} response - The JSON response from SAP CAR service.
 * @param {HTMLElement} sfsMarker - The DOM element representing the loading/potential state.
 * @param {string} errorLabel - The error message to display if item is unavailable.
 */
function handleCARAvailability(response, sfsMarker, errorLabel) {
    try {
        const data = response.vpsAvailabilityFromSapCar;
        if (!data) return;

        Object.entries(data).forEach(([pid, details]) => {
            const vAttrs = details.variationattributes;

            if (!details.available && $(SFS_SELECTORS.MAIN_CONTAINER).data('pid') == pid ) {
                // 1. Update Error Message if this unavailable item is the one currently selected
                updateAvailabilityUI(errorLabel);
                $(SFS_SELECTORS.A2B_BUTTON).prop('disabled', true);
            }

            Object.keys(vAttrs).forEach(attrId => {
                const attrValue = vAttrs[attrId];
                const container = document.querySelector(SFS_SELECTORS.ATTR_CONTAINER(attrId));

                if (container) {
                    const targetSpan = container.querySelector(SFS_SELECTORS.SWATCH_SPAN(attrValue));

                    if (targetSpan) {
                        const isSelected = targetSpan.classList.contains('selected');
                        
                        if (!details.available) {
                            // 1. Update Error Message if this unavailable item is the one currently selected
                            if (isSelected) {
                                updateAvailabilityUI(errorLabel);
                                $(SFS_SELECTORS.A2B_BUTTON).prop('disabled', true);
                            }
                            targetSpan.classList.add('unselectable');
                        } 
                    }
                }
            });
        });
    } catch (error) {
        // Silently fail
    } finally {
        // Always remove the marker to stop any "loading" animations in CSS
        if (sfsMarker) sfsMarker.remove();
    }

    // final check if all Attributes are unselectable
    const swatchWrap = document.querySelector('.cc-pdp__swatch-wrap--size');

    // Find any button that DOES NOT have an unselectable span
    const selectableButton = swatchWrap.querySelector('button:not(:has(span.unselectable))');

    if (!selectableButton) {
        updateAvailabilityUI(errorLabel);
    }
}

/**
 * Helper to update the availability hint text and icon state.
 * * @param {string} message - The error label to display.
 */
function updateAvailabilityUI(message) {

    let $hint = $(SFS_SELECTORS.HINT_AVAILABILITY);

    // If the first selector fails, handle the hidden variant
    if (!$hint.length) {
        $hint = $(SFS_SELECTORS.HINT_INFO_HIDDEN);
        if ($hint.length) {
            $hint.removeAttr('hidden');
        }
    }

    // Update Text
    $hint.find('span').text(message);

    // Update Styling
    $hint.removeClass('cc-hint--success').addClass('cc-hint--error');
    
    const $iconUse = $hint.find('use');

    // 3. Check if the icon exists before running logic
    if ($iconUse.length > 0) {
        // We use .attr() because jQuery handles the cross-browser href/xlink:href logic
        const currentHref = $iconUse.attr('href') || $iconUse.attr('xlink:href');

        if (currentHref) {
            const baseUrl = currentHref.split('#')[0];
            const newHref = `${baseUrl}#block`;
            
            // Update both just to be safe for all browsers
            $iconUse.attr('href', newHref);
            $iconUse.attr('xlink:href', newHref);
        }
    }
}